export interface IStateDefinitionSchema {
    id: string;
    organizationId?: string;
    name: string;
    color: string;
    order: number;
}
